<template>
  <div
    class="Re_form_group"
    :class="{ 'error': hasErrors }"
    :data-name="dataName"
  >
    <div class="Form_groupPassword">
      <label class="Re_form_label" v-if="label" :class="{'form_label': top}">{{ label }}</label>
      <input
        class="Re_form_control"
        :type="type"
        v-bind="$attrs"
        v-on="listeners"
        :class="{'form_control': top}"
        :placeholder="top ? null : placeholder"
      >
      <span class="password-eye" @click="toggleType">
        <app-icon name="password-eye" :class="{'show': isShowPassword }"/>
      </span>
    </div>
    <p class="tip-error" v-for="(error, index) in errors" :key="index">{{ label || placeholder }} {{ error }}</p>
  </div>
</template>

<script>
  import InputMixin from './input'
  import ValidationMixin from './validation'

  export default {
    mixins: [InputMixin, ValidationMixin],

    data () {
      return {
        isShowPassword: false
      }
    },

    computed: {
      type () {
        return this.isShowPassword ? 'text' : 'password'
      }
    },

    methods: {
      toggleType () {
        this.isShowPassword = !this.isShowPassword
      }
    }
  }
</script>

<style lang="scss">
  .password-eye {
    display: flex;
    position: absolute;
    right: .15rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    .icon-password-eye {
      color: #4a4a4a;
      opacity: 0.245;

      &.show {
        color: $blue;
        opacity: 1;
      }
    }
  }
</style>
